/**
 * Moving the brands_container to the brands-grid__content
 */
(() => {
  const brandsGrid = document.querySelector('.brands-grid');
  const brandsContainer = document.querySelector('.brands_container');
  if (!brandsGrid || !brandsContainer) return;

  brandsGrid.appendChild(brandsContainer);
})();

/**
 * Adding a link for each brand
 */
(() => {
  const brandsContainer = document.querySelector('.brands_container');
  if (!brandsContainer) return;

  const brands = brandsContainer.querySelectorAll('.tileparent .tile a');
  brands.forEach((brand) => {
    const shopProducts = document.createElement('p');
    shopProducts.textContent = 'Shop Products';
    shopProducts.classList.add('shop-products');
    brand.appendChild(shopProducts);
  });
})();
